import { render, staticRenderFns } from "./Lbutton.vue?vue&type=template&id=e20d98d8&scoped=true&"
import script from "./Lbutton.vue?vue&type=script&lang=js&"
export * from "./Lbutton.vue?vue&type=script&lang=js&"
import style0 from "./Lbutton.vue?vue&type=style&index=0&id=e20d98d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20d98d8",
  null
  
)

export default component.exports